import { hasCapability, type User } from "../base";

export const conversationSubscription = {
  update: (user: User) => hasCapability(user, "conversationSubscription.update"),
};
